<template>
  <div class="col-12">
    <div class="card-body">
      <div class="col-md-12 breadcumb"></div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/principal' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item>{{
          $t("app.modules.order_by_file_upload.upload_excel")
        }}</el-breadcrumb-item>
        <h6 style="margin-bottom: 0px" class="text-right">
          {{ $t("app.welcome") }} {{ this.$store.state.user.nombre }}
        </h6>
      </el-breadcrumb>

      <td class="col-11"></td>
      <td class="col-2">
        <h6 style="margin-bottom: 0px" class="text-right">{{ this.$store.state.user.cliente.razonSocial }}
        </h6>
      </td>

    </div>

    <p class="text-muted">
      {{ $t("app.modules.add_by_part_number.subtitle") }}
    </p>

    <br />

    <p class="text-muted">
      {{ $t("app.modules.add_by_part_number.text_help") }}
    </p>

    <el-divider></el-divider>

    <h4 slot="header" class="text-primary m-0">
      {{ $t("app.modules.order_by_file_upload.upload_excel") }}
    </h4>
    <div class="row" style="margin-top: 15px">
      <div class="col-12">
        <div class="form-group">
          <xlsx-read :file="file">
            <xlsx-sheets>
              <template #default="{ sheets }">
                <xlsx-json :sheet="sheets[0]">
                  <template #default="{ collection }">
                    <div v-if="collection" class="px-2; shopping_cart_menu">
                      <table class="table table-hover">
                        <thead v-if="collection.length >= 0">
                          <tr>
                            <td class="text-center">
                              {{
                                $t("app.modules.add_by_part_number.part_number")
                              }}
                            </td>
                            <td class="text-center">
                              {{ $t("app.modules.orders.headers.qty") }}
                            </td>
                            <!--<td class="text-center">{{ $t('app.modules.orders.headers.delivery_address') }}</td>-->
                          </tr>
                        </thead>
                        <tbody v-if="collection.length >= 0">
                          <tr v-for="item in sheetData" v-bind:key="item.id">
                            <td class="text-center">
                              {{ item.Product }}
                            </td>
                            <td class="text-center">
                              {{ item.Quantity }}
                            </td>

                            <!--
                          <td>
                            <el-select
                              :placeholder="$t('app.modules.product_family_detail.headers.select_address')"
                              size="large"
                              v-model="item.Address"
                              @change="onSelectAddress($event, item.Product)"
                            >
                              <el-option
                                v-for="(ad, index) in addresses"
                                :key="'address-'+index"
                                :label="ad.direccionString"
                                :value="ad.idDireccion"
                              >
                              </el-option>
                            </el-select>
                          </td>
                          -->
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </template>
                </xlsx-json>
              </template>
            </xlsx-sheets>
          </xlsx-read>
        </div>
      </div>
      
      <div class="col-12">

        <n-button :disabled="processBtnDisabled" @click.native="addProducto" class="btn btn-primary pull-right">{{
          $t("app.modules.order_by_file_upload.process") }}</n-button>

        <n-button class="btn btn-primary pull-right" @click.native="$refs.upload_input.click()">{{
          $t("app.modules.order_by_file_upload.select_file")
        }}</n-button>
        <input ref="upload_input" type="file" @change="onChange" style="display: none; clear: both; height: 50px" />
      
       
      </div>
    </div>
  </div>
</template>

<script>
import { integer } from "vee-validate/dist/rules";
import { getResponse } from "@/util/utilities";
import { XlsxRead, XlsxTable, XlsxJson, XlsxSheets } from "vue-xlsx";
import XLSX from "xlsx";
import moment from "moment";

export default {
  components: {
    XlsxJson,
    XlsxRead,
    XlsxSheets,
    XlsxTable,
  },
  computed: {
    priceTitle() {
      return this.item.price === 0
        ? this.$t("app.modules.product_family_detail.errors.not_available")
        : this.item.price + " " + this.item.moneda + "/" + this.item.unidad;
    },
  },
  data() {
    return {
      //detallPedidos: [],
      //productosValidos: [],
      //required_text: this.$t("app.general.required"),
      /*pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },*/
      processBtnDisabled: true,
      showDialog: false,
      file: null,
      collection: [],
      selectedSheet: null,
      modal_cart: false,
      item: {
        descripcion: "",
        quantity: 1,
        delivery_date: "",
        unidad: "",
        moneda: "",
        direccionId: "",
        price: 0,
        productoId: 0,
        origen_creacion: 0,
      },
      addresses: [],
      sheetData: [],
      idp: 0,
      idpc: 0,
      minQty: 0,
      arrAddress: [],
      detallesProducto: [],

    };
  },
  mounted() {



    EventBus.$on("show-add-by-fileupload", (item) => {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false,
      });

      console.log("EventBus");

      this.cancelAdd();

      if (this.$store.state.user.idClienteSAP > 0) {
        let paramClient = {
          clienteId: this.$store.state.user.idClienteSAP,
        };
        let requestDir = this.$http.post(
          route("Clientes/getDireccionesByCliente"),
          paramClient
        );
        let responseDir = getResponse(requestDir);

        if (responseDir != null) {
          this.addresses = responseDir.direcciones;
        }
      }


      this.$swal.close();
      this.showDialog = true;
    });
  },
  beforeDestroy() {
    //do something before destroying vue instance
    EventBus.$off("show-add-by-fileupload");
  },
  methods: {
    onChange(event) {
      console.log("ENTRO A ONCHAGE");
      console.log(JSON.stringify(event));

      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false,
      });

      this.file = null;
      this.file = event.target.files ? event.target.files[0] : null;
      this.processBtnDisabled = false;


      console.log("valor de file ---> " + JSON.stringify(this.file));

      if ((this.file != null) && (typeof (this.file) != 'undefined')) {
        console.log("ENTRO A FILE");


        this.sheetData = [];


        const header = ["Product", "Quantity"];

        const reader = new FileReader();
        reader.onload = (e) => {
          const bstr = e.target.result;

          const wb = XLSX.read(bstr, { type: "binary" });

          //console.log("wb ---> " + JSON.stringify(wb));

          //PARA PRUEBAS DE UN REGISTRO
          const wsname = wb.SheetNames[0];
          console.log("wsname ---> " + JSON.stringify(wsname));

          const ws = wb.Sheets[wsname];

          console.log("ws ---> " + JSON.stringify(ws));

          //XLSX.utils.sheet_add_aoa(ws, header);

          this.sheetData = XLSX.utils.sheet_to_json(ws, { header: header });
          //this.sheetData = XLSX.utils.sheet_to_json(ws, {header:[], skipHeader:true, origin: -1 });
          //this.sheetData = XLSX.utils.sheet_to_json(ws);
          console.log("sheetData ---> " + JSON.stringify(this.sheetData));
        };

        reader.readAsBinaryString(this.file);

        console.log("valor de file ---> " + JSON.stringify(this.file));


      }

      setTimeout(() => {
        this.$swal.close()
      }, 1000);

    },
    async getAddresses() {
      let paramClient = {
        clienteId: this.$store.state.user.idClienteSAP,
      };
      let requestDir = await this.$http.post(
        route("Clientes/getDireccionesByCliente"),
        paramClient
      );
      let responseDir = getResponse(requestDir);

      if (responseDir != null) {
        this.addresses = responseDir.direcciones;
      }
    },
    async loadPrecio() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false,
      });

      let param = {
        direccionId: this.item.direccionId,
        productoId: this.item.productoId,
        clienteIdSAP: this.$store.state.user.idClienteSAP,
      };

      this.item.price = 0;
      this.item.moneda = "";
      this.item.unidad = "";
      this.item.idProductoCliente = 0;

      if (!param.direccionId || !param.productoId || !param.clienteIdSAP) {
        this.$swal.close();
        return;
      }

      let request = await this.$http.put(
        route("Productos/getPrecioByProducto"),
        param
      );
      let response = getResponse(request, null);

      if (response && response.productos.length > 0) {
        let producto = response.productos[0];
        this.item.price = producto.precioUnitario;
        this.item.moneda = producto.moneda;
        this.item.unidad = producto.unidadMedida;
        this.item.idProductoCliente = producto.idProductoCliente;
      }

      this.$swal.close();
    },
    addProducto() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false,
      });

      let payload = {};
      let items = [];


      try {
        console.log("valor sheeData length" + JSON.stringify(this.sheetData.length));

        //console.log(this.arrAddress);

        if (this.sheetData.length > 0) {
          for (var i = 0; i < this.sheetData.length; i++) {
            var dt = new Date();

            console.log(
              "valor sheeData antes de if " + JSON.stringify(this.sheetData[i])
            );


            payload = {
              idProductoCliente: this.idpc,
              cantidad: this.sheetData[i].Quantity,
              fechaEntrega: moment(dt.setDate(dt.getDate() + 30)).format(
                "YYYY-MM-DD"
              ),
              material: this.sheetData[i].Product.toString(),
              origenCreacion: 0,
            };

            if (!payload.cantidad) {
              this.showDialog = false;
              this.cancelAdd();
              this.$swal.close();
              this.$router.push({
                name: "Solicitar Pedido",
              });

              throw new Error(
                this.$t("app.modules.product_family_detail.errors.no_quantity")
              );
            }

            if (!payload.material) {
              this.showDialog = false;
              this.cancelAdd();
              this.$swal.close();
              this.$router.push({
                name: "Solicitar Pedido",
              });

              throw new Error(
                this.$t("app.modules.product_family_detail.errors.no_material")
              );
            }

            items.push(payload);

            //EventBus.$emit("add-to-cart", payload);

          }
        }

        EventBus.$emit("add-to-cart-list", items);


        this.showDialog = false;
        //let items = [];
        this.cancelAdd();


        this.$router.push({
          name: "Solicitar Pedido",
        });

      } catch (e) {
        console.log("Error", e);
        this.notifyMessage("danger", e.message);
      } finally {

        this.$swal.close();
      }
    },
    cancelAdd() {
      this.item = {
        descripcion: "",
        quantity: 1,
        delivery_date: "",
        unidad: "",
        moneda: "",
        direccionId: "",
        price: 0,
        productoId: 0,
      };
      this.modal_cart = false;
      this.addresses = [];
      this.arrAddress = [];
      this.file = null;
      this.sheetData = [];
      this.collection = [];
      this.selectedSheet = null;
      this.idp = 0;
      this.idpc = 0;
      this.minQty = 0;
      this.arrAddress = [];
      this.detallesProducto = [];
      this.processBtnDisabled = true;

    },
    async getProductPrice(material, clienteIdSAP, direccionId) {
      var params = {
        material: material,
        clienteIdSAP: clienteIdSAP,
        direccionId: direccionId,
      };
      await this.$http.put(route("Productos/getPrecioByMaterial"), params).then(
        (response) => {
          console.log(response);
          if (response.body.code === 200) {
            var res = response.body.productos;
            if (res.length > 0) {
              this.idpc = res[0].idProductoCliente;
              this.idp = res[0].producto_idProducto;
              this.minQty = res[0].cantidadMinima;
            } else {
              this.idpc = 0;
              this.idp = 0;
              this.minQty = 0;
            }
          } else {
            this.notifyMessage("danger", this.$t("app.cart.promps.addFail"));
            this.idpc = 0;
            this.idp = 0;
            this.minQty = 0;
          }
        },
        (error) => {
          console.error(error);
          this.notifyMessage("danger", this.$t("app.promps.error"));
          this.idpc = -1;
          this.idp = -1;
          this.minQty = -1;
        }
      );
    },
    onSelectAddress(event, producto) {
      this.arrAddress.push({
        prod: producto,
        iddir: event,
      });
    },
    async getProductDetail(id) {
      const params = {
        idProducto: id,
      };
      try {
        let productoRequest = await this.$http.post(
          route("Productos/getInformacionProducto"),
          params
        );

        let producto = getResponse(
          productoRequest,
          null,
          (body) => body.producto
        );
        producto = producto || null;

        this.detallesProducto = producto;
        // this.handleProduct(this.producto);
      } catch (e) {
        console.error(e);
      }
    },
    closeModal() {
      this.cancelAdd();
    }
  },
};
</script>
